import { useParams } from "react-router-dom"
import { Box, type SxProps, type Theme } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import { useAppSelector } from "hooks/redux"
import OPTooltip from "components/material/tooltip"
import HomeHeader from "modules/home-header"
import ShareMyView from "modules/share-my-view"
import { getCurrentAssetDetails, getCurrentAssetInfoContent, getSelectedModelId, getShareMyViewProps } from "./selectors"

const INFO_SX = { display: "flex" } satisfies SxProps<Theme>
const INFO_ICON_SX = { marginTop: "0.1rem", marginLeft: "0.5rem" } satisfies SxProps<Theme>

interface Props {
  account: string
}

export default function AnalyzeCompositeSecurityHeader({ account }: Props) {
  const params = useParams()
  const asset = useAppSelector(state => getCurrentAssetDetails(state, { params }))
  const infoContent = useAppSelector(state => getCurrentAssetInfoContent(state, { params }))
  const modelId = useAppSelector(getSelectedModelId)
  const shareMyViewProps = useAppSelector(state => getShareMyViewProps(state, { params }))

  return <HomeHeader
    account={account}
    title={asset ? asset.name : "Composite Asset"}
    modelId={modelId}
    noShadow
    // The share link's date range is clamped by the asset's availability, read from the same slot:
    // offering it before this asset is current would share the outgoing one's range.
    actions={asset ? <ShareMyView {...shareMyViewProps} /> : null}
  >
    {infoContent && <Box id="composite-asset-info" sx={INFO_SX}>
      <OPTooltip title={infoContent}>
        <InfoOutlined id="composite-asset-info-icon" fontSize="small" sx={INFO_ICON_SX} />
      </OPTooltip>
    </Box>}
  </HomeHeader>
}
